<template>
  <div>
    <div class="columns is-align-items-center">
      <div class="column">
        <LinkEntity :payload="payload.data" :additional_data="{ resource_type: 'Position' }" />
      </div>
      <div class="column">
        <LinkEntity :payload="payload.data.company" />
      </div>
    </div>
    <div class="columns mt-5">
      <div class="column">
        <QuestionEditor :payload="{ question: urgency, resource_type: 'Position', resource_id: payload.data.id }" />
      </div>
      <div class="column">
        <button @click="onClickOutsource" class="button is-info">Outsource</button>
      </div>
      <div class="column">
        <button @click="onClickDesignatedPositions" class="button is-info">משרה ייעודית</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import LinkEntity from '@/components/LinkEntity'
import QuestionEditor from '@/components/QuestionEditor'
export default {
  name: 'ModalTurnOnFlame',
  components: {
    LinkEntity,
    QuestionEditor
  },
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      urgency: null
    }
  },
  async created () {
    this.$network_utils.getResourceQuestions({
      current_type: 'Position',
      current_resource_id: this.payload.data.id,
      designators: 'urgency'
    }).then(response => {
      this.urgency = response[0]
    })
  },
  methods: {
    ...mapMutations('modals', ['create']),
    onClickOutsource () {
      this.create({
        designator: 'edit-outsource-position-form-modal',
        component_name: 'OutsourcePositionForm',
        env_position_id: this.payload.data.id,
        modal_title: 'Outsource - ' + this.payload.data.title
      })
    },
    onClickDesignatedPositions () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        data: this.payload,
        init_designator: 'designated_position',
        init_priority: 90,
        resource_type: 'Position',
        resource_id: this.payload.id,
        modal_title: 'Create new Alert',
        suitcase: true
      })
    }
  }
}
</script>

<style scoped>
.note {
  margin-bottom: 10px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.18);
}
</style>
